import React, { useState } from 'react';
import { Stack, Button, Card, CardContent, Typography, Fab } from '@mui/material';
import { SmallFormDateField } from '../../../../components/small-fields/SmallFormDateField';
import { SmallFormTextField } from '../../../../components/small-fields/SmallFormTextField';
import { formatDate } from '../../../../services/functions';
import UndoIcon from '@mui/icons-material/Undo';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageModal from './ImageModal';
import defaultImage from './default.png';

export default function EmployeeDataBase({ formik, preview, loading, fileInputRef, handleChangeImage, handlePhotoChange, isDefaultPhoto }) {
  const [openImage, setOpenImage] = React.useState(false);

  return (
    <Stack sx={{ mt: 2 }} direction="row" spacing={2}>
      <Card sx={{ width: '200px', height: '250px' }}>
        <CardContent>
          <img
            src={preview}
            style={{ objectFit: 'cover', width: '150px', height: '150px', margin: '0 auto', border: '2px solid #00AB55', borderRadius: '16px', cursor: 'zoom-in' }}
            onClick={() => setOpenImage(true)}
          >
          </img>
          <Stack style={{ marginTop: '10px' }} direction="row" justifyContent="space-between">
            <Button variant="contained" component="label" disabled={loading}>
            Zmień
              <input type="file" accept="image/*" hidden ref={fileInputRef} onChange={handleChangeImage}/>
            </Button>
            {
              formik.values.is_photo_changed || formik.values.is_photo_deleted
                ? <Fab size="small" color="secondary" onClick={() => handlePhotoChange(false)} disabled={loading}>
                  <UndoIcon />
                </Fab>
                : <Fab size="small" color="error" disabled={preview === defaultImage || isDefaultPhoto || loading} onClick={() => handlePhotoChange(true)}>
                  <DeleteIcon />
                </Fab>
            }
          </Stack>
        </CardContent>
      </Card>
      <Card sx={{ flex: 1 }}>
        <CardContent>
          <Stack spacing={2}>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Imię</Typography>
              <SmallFormTextField
                name="name"
                placeholder="Imię"
                value={formik.values.name}
                onChange={formik.handleChange}
                helperText={formik.errors.name}
                error={formik.errors.name && formik.touched.name}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Nazwisko</Typography>
              <SmallFormTextField
                name="surname"
                placeholder="Naziwsko"
                value={formik.values.surname}
                onChange={formik.handleChange}
                helperText={formik.errors.surname}
                error={formik.errors.surname && formik.touched.surname}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Data urodzenia</Typography>
              <SmallFormDateField
                name="birth_date"
                value={formik.values.birth_date}
                onChange={val => formik.setFieldValue('birth_date', formatDate(val))}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Miejsce urodzenia</Typography>
              <SmallFormTextField
                name="place_of_birth"
                placeholder="Miejsce urodzenia"
                value={formik.values.place_of_birth}
                onChange={formik.handleChange}
                helperText={formik.errors.place_of_birth}
                error={formik.errors.place_of_birth && formik.touched.place_of_birth}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Email</Typography>
              <SmallFormTextField
                name="correspondence_email"
                placeholder="Email"
                value={formik.values.correspondence_email}
                onChange={formik.handleChange}
                helperText={formik.errors.correspondence_email}
                error={formik.errors.correspondence_email && formik.touched.correspondence_email}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Telefon</Typography>
              <SmallFormTextField
                name="phone"
                placeholder="Telefon"
                value={formik.values.phone}
                onChange={formik.handleChange}
                helperText={formik.errors.phone}
                error={formik.errors.phone && formik.touched.phone}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>PESEL</Typography>
              <SmallFormTextField
                name="pesel"
                placeholder="PESEL"
                value={formik.values.pesel}
                onChange={formik.handleChange}
                helperText={formik.errors.pesel}
                error={formik.errors.pesel && formik.touched.pesel}
                sx={{ width: '75%' }}
              />
            </Stack>
          </Stack>
        </CardContent>
      </Card>
      <Card sx={{ flex: 1 }}>
        <CardContent>
          <Stack spacing={2}>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Ulica</Typography>
              <SmallFormTextField
                name="address.street"
                placeholder="Ulica"
                value={formik.values.address.street}
                onChange={formik.handleChange}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Nr domu/mieszkania</Typography>
              <SmallFormTextField
                name="address.house"
                placeholder="Nr domu/mieszkania"
                value={formik.values.address.house}
                onChange={formik.handleChange}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Miasto</Typography>
              <SmallFormTextField
                name="address.city"
                placeholder="Miasto"
                value={formik.values.address.city}
                onChange={formik.handleChange}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Kod pocztowy</Typography>
              <SmallFormTextField
                name="address.postal_code"
                placeholder="Kod pocztowy"
                value={formik.values.address.postal_code}
                onChange={formik.handleChange}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Nazwa Firmy</Typography>
              <SmallFormTextField
                name="company_name"
                placeholder="Nazwa firmy"
                value={formik.values.company_name}
                onChange={formik.handleChange}
                helperText={formik.errors.company_name}
                error={formik.errors.company_name && formik.touched.company_name}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>NIP</Typography>
              <SmallFormTextField
                name="nip"
                placeholder="NIP"
                value={formik.values.nip}
                onChange={formik.handleChange}
                helperText={formik.errors.nip}
                error={formik.errors.nip && formik.touched.nip}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Numer konta</Typography>
              <SmallFormTextField
                name="account_number"
                placeholder="Numer konta"
                value={formik.values.account_number}
                onChange={formik.handleChange}
                helperText={formik.errors.account_number}
                error={formik.errors.account_number && formik.touched.account_number}
                sx={{ width: '75%' }}
              />
            </Stack>
          </Stack>
        </CardContent>
      </Card>
      <ImageModal open={openImage} handleClose={() => setOpenImage(false)} src={preview}/>
    </Stack>);
};
